// extracted by mini-css-extract-plugin
export var changeIcon = "_5h-4";
export var clickable = "_5h-8";
export var container = "_5h-0";
export var divider = "_5h-7";
export var externalLinkIcon = "_5h-1";
export var green = "_5h-5";
export var helpCircleIcon = "_5h-3";
export var iconButton = "_5h-2";
export var red = "_5h-6";